var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { getLoginType, getUserData, isLogged, logout, setAuth, } from '../logic/auth';
import { footer } from '../utils/theme';
import { ToS } from './ToS';
import { TraditionalLogin } from './TraditionalLogin';
import { cleanUserData, extractWorkEmail, hasEmailDomainData, hasUserAuthData, isRenew, } from '../utils/misc';
import { Logo } from './Logo';
import { SocialChooseStep } from './SocialChooseStep';
import { ChooseEmailDomain } from './ChooseEmailDomain';
import { VerificationMessage } from './VerificationMessage';
import { WaitingReview } from './WaitingReview';
import { ChooseRole } from './ChooseRole';
import { Success } from './Success';
import { BuyerToConsumer } from './BuyerToConsumer';
import { mergeConfig } from '../logic/config';
import { classNames, registerClass } from '@food/css-manager';
import { ErrorMessage } from '@food/ui/build/dist/src/ErrorMessage';
import { isSocial, } from '../types';
import { TemporaryConsumer } from './TemporaryConsumer';
import { track } from '@food/tracking';
import { oAuthLogin } from '../utils/oauth';
import { InsertWorkEmail } from './InsertWorkEmail';
import { AuthSteps, responseToPhase } from '../logic/steps';
import { SwitchToSocialStep } from './SwitchToSocial';
import { ErrorStep } from './ErrorStep';
import { RememberSocialStep } from './RememberSocialStep';
import { VerifyLinkExpired } from './VerifyLinkExpired';
import { authTrackOverride } from '../utils/track';
import { UserRole } from '../server-types';
import { ChooseUpgradeRole } from './ChooseUpgradeRole';
import * as Sentry from '@sentry/browser';
import { withRouter } from 'react-router';
import { event } from 'react-ga';
export var SOCIAL_LOGIN_LAYOUTS;
(function (SOCIAL_LOGIN_LAYOUTS) {
    SOCIAL_LOGIN_LAYOUTS["STANDARD"] = "STANDARD";
    SOCIAL_LOGIN_LAYOUTS["COMPACT"] = "COMPACT";
})(SOCIAL_LOGIN_LAYOUTS || (SOCIAL_LOGIN_LAYOUTS = {}));
export var socialLoginLayoutChooser = function (width) {
    return width > 800 ? SOCIAL_LOGIN_LAYOUTS.STANDARD : SOCIAL_LOGIN_LAYOUTS.COMPACT;
};
// data l'ultima risposta del server, restituisco i dati necessari per la prossima richiesta
// ancora in costruzione
// TODO spostare in un file apposta
/*const pickArgsFromResponse = (response: IServerResponse): any => {
    const base: any = {};
    if (response.cryptoRenewToken) {
        base.cryptoRenewToken = response.cryptoRenewToken;
    }
    return base;
};*/
var isPayloadWithChoices = function (response) {
    return !!response.choices;
};
// data l'ultima risposta, ne prendo i tos
// TODO spostare in un file apposta
var pickToSFromResponse = function (response) { return response.choices; };
// data l'ultima risposta, ne prendo il bearer
// TODO spostare in un file apposta
/*const pickBearerFromResponse = (response: IServerResponse): string =>
    response && response.userAuth && response.userAuth.authorization;*/
// data l'ultima risposta, prende il tipo di social usato per il login / a cui e' accoppiato l'utente
// TODO spostare in un file apposta
var pickSocialTypeFromResponse = function (response) {
    var _a;
    var userSocialtype = (_a = response === null || response === void 0 ? void 0 : response.userAuth) === null || _a === void 0 ? void 0 : _a.userSocialtype;
    return isSocial(userSocialtype) ? userSocialtype : undefined;
};
var pickEmailDomainsFromResponse = function (response) { return response === null || response === void 0 ? void 0 : response.choices; };
var loadingStep = registerClass(function (theme) { return "\nwidth: 100%;\nmin-height: 20vh;\n> div {\n\ttext-align: center;\n\tpadding: " + theme.ratios.l / 2 + "em;\n}"; });
var style = registerClass(function (theme) { return "\nmax-width: 900px;\nmin-width: 500px;\nbackground: " + theme.colors.white + ";\nline-height: " + theme.ratios.l + "em;\ncolor: " + theme.colors.ink + ";\nmargin-bottom: " + theme.ratios.l * theme.font.baseSize + "px;\n\n> h2 {\n\tfont-size: " + theme.ratios.xl + "em;\n\tline-height: " + theme.ratios.xl + "em;\n\tcolor: " + theme.colors.ink + ";\n\tbackground-color: " + theme.colors.grey.light + ";\n\ttext-align: center;\n\tmargin-bottom: " + (theme.ratios.l / 2) * theme.font.baseSize + "px;\n}\n\n> section {\n\tpadding: " + theme.ratios.l * theme.font.baseSize + "px;\n\tpadding-top: " + (theme.ratios.l / 2) * theme.font.baseSize + "px\n\n\t.skip {\n\t\tfont-size: " + theme.ratios.s + "em;\n\t\ttext-align: center;\n\t}\n\n\ta {\n\t\tcursor: pointer;\n\t\tcolor: " + theme.colors.grey.plain + ";\n\t\ttext-decoration: underline;\n\t}\n\t\n\t> p, > div > p {\n\t\tmargin-top: " + theme.font.baseSize + "px;\n\t\t\n\t\t&:first-child {\n\t\t\tmargin-top: 0;\n\t\t}\n\t}\n}"; });
export var StepContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: style }, children));
};
function socialLoginFactory(t) {
    return withRouter(/** @class */ (function (_super) {
        __extends(SocialLogin, _super);
        function SocialLogin(props) {
            var _this = _super.call(this, props) || this;
            _this.renderError = function (step) {
                var _a = _this.state, errors = _a.errors, socialType = _a.socialType;
                var tokens = _this.props.tokens;
                if (errors && errors.length) {
                    return (React.createElement("div", null, errors.map(function (e) {
                        var key = e.key, type = e.type;
                        if (key === 'grantToken.email' &&
                            socialType === 'FACEBOOK') {
                            key = 'grantToken.email facebook';
                        }
                        var errorId = key
                            ? key + " " + type + " error"
                            : 'generic error';
                        // ci sono alcuni casi in cui gli errori non devono venire mostrati in quanto parte di un normale
                        // svolgimento della procedura di login. Ad esempio, quando sto associando un sfContactId a un
                        // utente con bearer scaduto ricevo un errore, ma non si tratta di un malfunzionamento.
                        // Qui controllo questi casi e, se si verificano, non restituisco errore.
                        if ((step === AuthSteps.CREDENTIAL_INPUT_TRADITIONAL ||
                            step === AuthSteps.CREDENTIAL_INPUT_SOCIAL) &&
                            key === 'options.authToken' &&
                            type === 'INVALID_VALUE' &&
                            tokens.sfContactId) {
                            return React.createElement("span", null);
                        }
                        // di default restistuisco semplicemente un messaggio di errore per ogni errore
                        return (React.createElement(ErrorMessage, { key: (key || +new Date()) + ' error', error: t(errorId) }));
                    })));
                }
                return null;
            };
            _this.deriveFromState = function (newState) {
                var _a, _b;
                var s = newState || _this.state;
                var config = _this.state.config;
                return {
                    sourceApp: config.TARGET_SITE,
                    role: s.role,
                    cryptoRenewToken: (_b = (_a = s.serverAuth) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.cryptoRenewToken,
                    workEmail: s.email,
                    userSocialLinkToken: s.userSocialLinkToken,
                    tosApproved: s.tosAccepted,
                    newsletterAccepted: s.newsletterAccepted,
                    EmailDomain_id: s.emailDomain,
                };
            };
            _this.historySetState = function (state) {
                _this.setState(__assign(__assign({}, state), { history: _this.state.history.concat([__assign({}, _this.state)]) }));
            };
            /**
             * Funzione per controllare, al caricamento del componente, il token nell'url con il server
             * Puo' portare al SUCCESS, alla scelta del dominio, o a un messaggio di declassamento da BUYER a CONSUMER
             */
            _this.performVerify = function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, authManager, tokens, redirectOnLogin, authFromState, serverAuth;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, authManager = _a.authManager, tokens = _a.tokens, redirectOnLogin = _a.redirectOnLogin;
                            authFromState = this.deriveFromState();
                            if (authFromState.cryptoRenewToken) {
                                // se sei già loggato, non devo fare il controllo
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, authManager.authenticate(authFromState, tokens, true, redirectOnLogin)];
                        case 1:
                            serverAuth = _b.sent();
                            if (!serverAuth.success ||
                                serverAuth.payload.EmailDomainRow ||
                                serverAuth.payload.userStatus === 'WAITING_REVIEW') {
                                this.parseServerResponse(serverAuth);
                            }
                            else {
                                this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            _this.tryTraditionalLogin = function (_a) {
                var email = _a.email, password = _a.password;
                return __awaiter(_this, void 0, void 0, function () {
                    var _b, authManager, tokens, loginResult;
                    var _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _b = this.props, authManager = _b.authManager, tokens = _b.tokens;
                                this.setState({ loading: true });
                                return [4 /*yield*/, authManager.authenticate(__assign(__assign({}, this.deriveFromState(this.state)), { email: email,
                                        password: password }), tokens, false)];
                            case 1:
                                loginResult = _d.sent();
                                if (!loginResult.success) return [3 /*break*/, 5];
                                if (!(((_c = loginResult.payload.userAuth) === null || _c === void 0 ? void 0 : _c.auth.user.role) ===
                                    UserRole.Internal)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.successfulLoginHandler(loginResult, 'TRADITIONAL')];
                            case 2:
                                _d.sent();
                                return [2 /*return*/];
                            case 3:
                                // segnalo ad analytics che ho avuto un login da social
                                event({
                                    category: 'User',
                                    action: 'Sign in',
                                    label: 'credentials',
                                });
                                this.setState({
                                    loading: false,
                                    serverAuth: loginResult,
                                });
                                _d.label = 4;
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                // ho ricevuto un errore, parso la risposta e la gestisco
                                this.parseServerResponse(loginResult, {
                                    errors: [loginResult.payload],
                                });
                                _d.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            };
            _this.trySocialUpgrade = function (social) { return __awaiter(_this, void 0, void 0, function () {
                var _a, authManager, tokens, socialType, grantToken, serverAuth, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, authManager = _a.authManager, tokens = _a.tokens;
                            socialType = authManager.SOCIAL_TYPES[social];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 5, , 6]);
                            return [4 /*yield*/, oAuthLogin({
                                    socialType: socialType,
                                })];
                        case 2:
                            grantToken = _b.sent();
                            if (!grantToken) return [3 /*break*/, 4];
                            return [4 /*yield*/, authManager.authenticate(__assign(__assign({}, this.deriveFromState(this.state)), { grantToken: grantToken, socialType: socialType.key }), tokens, true)];
                        case 3:
                            serverAuth = _b.sent();
                            if (serverAuth.payload.userAuth &&
                                serverAuth.payload.userAuth.success === true &&
                                serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                                this.successfulLoginHandler(serverAuth, social);
                            }
                            else {
                                this.parseServerResponse(serverAuth, {
                                    grantToken: grantToken,
                                    errors: [serverAuth.payload],
                                });
                            }
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            e_1 = _b.sent();
                            console.error(e_1);
                            console.warn('Access to social data denied, nothing to do!');
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            }); };
            _this.trySocialLogin = function (_a) {
                var fixedSocial = _a.fixedSocial;
                return __awaiter(_this, void 0, void 0, function () {
                    var _b, authManager, tokens, socialType, grantToken, changedState, newState, serverAuth, e_2;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _b = this.props, authManager = _b.authManager, tokens = _b.tokens;
                                socialType = authManager.SOCIAL_TYPES[fixedSocial];
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 5, , 6]);
                                return [4 /*yield*/, oAuthLogin({
                                        // sourceApp: config.TARGET_SITE,
                                        socialType: socialType,
                                    })];
                            case 2:
                                grantToken = _c.sent();
                                if (!grantToken) return [3 /*break*/, 4];
                                changedState = {
                                    socialType: socialType.key,
                                    grantToken: grantToken,
                                };
                                newState = __assign(__assign(__assign({}, this.state), changedState), { authToken: null });
                                return [4 /*yield*/, authManager.authenticate(__assign(__assign({}, this.deriveFromState(newState)), { grantToken: grantToken, socialType: socialType.key }), tokens, false)];
                            case 3:
                                serverAuth = _c.sent();
                                if (serverAuth.payload.userAuth &&
                                    serverAuth.payload.userAuth.success === true) {
                                    // segnalo ad analytics che ho avuto un login da social
                                    // nota: se l'utente e' in WAITING REVIEW ma si e' autenticato devo comunque avvisare analytics di avvenuto login
                                    event({
                                        category: 'User',
                                        action: 'Sign in',
                                        label: 'social',
                                    });
                                }
                                if (serverAuth.payload.userAuth &&
                                    serverAuth.payload.userAuth.success === true &&
                                    serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                                    // save and complete
                                    this.successfulLoginHandler(serverAuth, socialType.key);
                                }
                                else {
                                    // not registered or waiting review, continue with registration
                                    this.parseServerResponse(serverAuth, __assign({}, changedState));
                                }
                                return [3 /*break*/, 4];
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                e_2 = _c.sent();
                                console.error(e_2);
                                console.warn('Access to social data denied, nothing to do!');
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            };
            // save registration
            _this.performRegister = function (newState) { return __awaiter(_this, void 0, void 0, function () {
                var _a, authManager, tokens, redirectOnLogin, serverAuth;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, authManager = _a.authManager, tokens = _a.tokens, redirectOnLogin = _a.redirectOnLogin;
                            return [4 /*yield*/, authManager.authenticate(this.deriveFromState(newState), tokens, false, redirectOnLogin)];
                        case 1:
                            serverAuth = _b.sent();
                            if (serverAuth.success) {
                                // segnalo ad analytics che ho avuto un nuovo utente registrato
                                event({
                                    category: 'User',
                                    action: 'Registration',
                                    label: serverAuth.payload.userStatus,
                                });
                            }
                            // check if already registered,
                            if (serverAuth.success &&
                                serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                                /*if (serverAuth.payload.EmailDomainRow) {
                                // sono in fase di registrazione, mando alla schermata di successo
                                this.setState({
                                    // phase: 'SUCCESS',
                                    loading: false,
                                    errors: null,
                                    serverAuth,
                                });
                            } else if () {
                                this.setState({
                                    // phase: 'WAITING_REVIEW',
                                    loading: false,
                                    errors: null,
                                    serverAuth,
                                });
                            } else {*/
                                this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype || 'TRADITIONAL');
                                // }
                            }
                            else {
                                this.parseServerResponse(serverAuth, newState);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            _this.acceptTos = function (_a) {
                var tosLocalId = _a.id, newsletter = _a.newsletter;
                var stateUpdate = {
                    tosAccepted: tosLocalId,
                    newsletterAccepted: newsletter,
                };
                var newState = __assign(__assign({}, _this.state), stateUpdate);
                _this.performRegister(newState);
                _this.setState(newState);
            };
            _this.roleChooser = function (role) {
                var newState = {
                    role: role,
                };
                _this.setState(__assign(__assign({}, newState), { loading: true }));
                _this.performRegister(__assign(__assign({}, _this.state), newState));
            };
            // TODO estrarne almeno una parte
            _this.upgradeRole = function (role) { return __awaiter(_this, void 0, void 0, function () {
                var _a, tokens, authManager, stateChanges, newState, serverAuth;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, tokens = _a.tokens, authManager = _a.authManager;
                            stateChanges = {
                                role: role,
                                loading: true,
                            };
                            this.setState(stateChanges);
                            newState = __assign(__assign({}, this.state), stateChanges);
                            return [4 /*yield*/, authManager.authenticate(this.deriveFromState(newState), tokens, true)];
                        case 1:
                            serverAuth = _b.sent();
                            if (serverAuth.success &&
                                serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                                this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype || 'TRADITIONAL');
                                // }
                            }
                            else {
                                this.parseServerResponse(serverAuth, newState);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            _this.back = function () {
                var history = _this.state.history;
                var oldState = history.pop();
                if (oldState) {
                    _this.setState(__assign(__assign({}, oldState), { email: undefined, errors: undefined, loading: false, forcedChangeWorkEmail: false, serverAuth: oldState.serverAuth || undefined }));
                }
                else {
                    // back without previus state
                    Sentry.withScope(function (scope) {
                        scope.setExtra('oldState', oldState);
                        Sentry.captureException(new Error('back without previus state'));
                    });
                }
            };
            //
            _this.clearTokens = function () {
                var _a = _this
                    .props, location = _a.location, history = _a.history;
                var search = location.search, pathname = location.pathname;
                if (search) {
                    history.replace(pathname);
                }
            };
            // funzione per chiudere la modale, qualora si trattasse di modale
            // in effetti non fa altro che pulire l'url e chiamare un eventuale listener
            _this.close = function () {
                // TODO il close, se chiamato su step post autenticazione, dovrebbe lanciare il success handler
                // TODO il close dovrebbe essere chiamato con un parametro per distinguere i caso in cui il login e' andato a buon fine
                var onClose = _this.props.onClose;
                _this.clearTokens();
                if (onClose) {
                    onClose();
                }
            };
            _this.parseServerResponse = function (serverAuth, changedState) {
                if (changedState === void 0) { changedState = {}; }
                var config = _this.state.config;
                // qualsiasi sia lo stato emergente da questa elaborazione, avra' queste caratteristiche
                var newState = __assign(__assign({}, changedState), { serverAuth: serverAuth, loading: false });
                /**
                 * Ci sono casi in cui non imposto serverAuth e quindi mi perderei
                 * serverAuth.payload.cryptoRenewToken con conseguente errore sulla
                 * chiamata successiva perché manca un qualsiasi metodo di autenticazione.
                 */
                if (serverAuth.payload.cryptoRenewToken) {
                    _this.setState({
                        serverAuth: serverAuth,
                    });
                }
                if (serverAuth.payload.key) {
                    if (serverAuth.payload.key.includes('options.tosApproved')) {
                        // potrebbe avermi passato anche un cryptoRenewToken
                        _this.historySetState(newState);
                    }
                    else if (serverAuth.payload.key.includes('options.role')) {
                        // sono nel caso in cui chiedo il ruolo dell'utente da registrare
                        if (config.AUTH_ROLES.length === 1 &&
                            config.AUTH_ROLES[0] === UserRole.Consumer) {
                            // se solo il ruolo CONSUMER e' abilitato alla registrazione lo seleziono automaticamente
                            _this.roleChooser(UserRole.Consumer);
                            return false;
                        }
                        else {
                            // altrimenti mostro una scelta di pulsanti per scegliere i diversi ruoli
                            // mi serve che sia una `historySetState` perche' devo poter tornare indietro
                            _this.historySetState(newState);
                            return false;
                        }
                    }
                    else if (serverAuth.payload.key.includes('options.userSocialLinkToken') &&
                        isSocial(_this.state.socialType)) {
                        // userSocialLinkToken non valido, rifai la chiamata senza valorizzare userSocialLinkToken
                        _this.trySocialLogin({ fixedSocial: _this.state.socialType });
                    }
                    else if (serverAuth.payload.key.includes('options.workEmailRoleToken') &&
                        isSocial(_this.state.socialType)) {
                        // workEmailRoleToken non valido, rifai la chiamata senza valorizzare workEmailRoleToken
                        _this.setState(__assign(__assign({}, newState), { workEmailRoleToken: null }));
                        _this.trySocialLogin({ fixedSocial: _this.state.socialType });
                    }
                    else if ((serverAuth.payload.key === 'options.email' &&
                        serverAuth.payload.type === 'INVALID_VALUE') ||
                        (serverAuth.payload.key === 'options.workEmail' &&
                            serverAuth.payload.type === 'MUST_BE_UNIQUE') ||
                        (serverAuth.payload.key === 'options.workEmail' &&
                            serverAuth.payload.type === 'INVALID_VALUE')) {
                        // sono nel caso di login errato, tentativo di registrazione con email gia' usata o con dominio CONSUMER_ONLY
                        _this.setState({
                            loading: false,
                            errors: [serverAuth.payload],
                        });
                        return false;
                    }
                    else {
                        _this.historySetState(__assign(__assign({}, newState), { loading: false, errors: [serverAuth.payload] }));
                        return false;
                    }
                }
                else if (serverAuth.payload.status === 201 ||
                    serverAuth.payload.userStatus === 'NOT_VERIFIED') {
                    // siamo nel caso in cui e' stata inserita una workEmail. Tendenzialmente mostriamo un messaggio di
                    // conferma che invita a convalidare la mail
                    _this.historySetState(__assign(__assign({}, newState), { workEmail: serverAuth.payload.workEmail }));
                    // }
                }
                else {
                    // bho??
                    // caso timeout? errore generico?
                    _this.historySetState(newState);
                    return true;
                }
                return true;
            };
            _this.orLogout = function () {
                logout();
                _this.close();
            };
            _this.successfulLoginHandler = function (serverResponse /*: IServerResponse*/, loginType) {
                var onSuccess = _this.props.onSuccess;
                track(__assign(__assign({}, authTrackOverride), { action: {
                        type: 'successful_login',
                        authData: cleanUserData(serverResponse.payload.userAuth),
                    } }));
                var userAuth = serverResponse.payload.userAuth;
                if (!(userAuth === null || userAuth === void 0 ? void 0 : userAuth.authorization)) {
                    Sentry.withScope(function (scope) {
                        scope.setExtra('userAuth', userAuth);
                        Sentry.captureException(new Error('successfulLoginHandler but userAuth without authorization'));
                    });
                }
                else {
                    // l'handler del success deve sempre eseguire DOPO aver impostato a livello globale i dati di autenticazione!!
                    setAuth(userAuth, loginType);
                    _this.clearTokens();
                    if (onSuccess !== undefined) {
                        onSuccess();
                    }
                }
            };
            var config = props.config, fixedSocial = props.fixedSocial, startTraditional = props.startTraditional, instantUpgradeRole = props.instantUpgradeRole, tokens = props.tokens;
            var mergedConfig = mergeConfig(config);
            var workEmailVerifyToken = tokens.workEmailVerifyToken, sfContactId = tokens.sfContactId;
            if (workEmailVerifyToken) {
                // sono in una pagina che deve verificare una email di lavoro, appena mi avvio faccio una chiamata
                // probabilmente e' un brutto modo di eseguire un cambio stato applicazione
                _this.state = {
                    loading: true,
                    history: [],
                    socialInput: !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                    config: mergedConfig,
                    forcedChangeWorkEmail: false,
                };
                _this.performVerify();
            }
            else if (sfContactId && isLogged()) {
                // sono in una pagina che deve collegare ad un account un account salesforce tramite il token passato in
                // url. Nel caso l'utente sia loggato provo a fare la chiamata e mostro qualcosa solo in caso di errore.
                _this.state = {
                    loading: true,
                    history: [],
                    socialInput: !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                    config: mergedConfig,
                    forcedChangeWorkEmail: false,
                };
                _this.performVerify();
            }
            else if (instantUpgradeRole && isLogged()) {
                // sono in una pagina che deve verificare una email di lavoro, appena mi avvio faccio una chiamata
                // probabilmente e' un bruttor modo di eseguire un cambio stato applicazione
                _this.state = {
                    loading: true,
                    history: [],
                    socialInput: !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                    config: mergedConfig,
                    forcedChangeWorkEmail: false,
                };
                _this.upgradeRole(instantUpgradeRole);
            }
            else {
                _this.state = SocialLogin._initState(props);
                if (fixedSocial) {
                    // ho cliccato su un qualche pulsante con richiesta di login social, vado a fare direttamente la
                    // richiesta per il login social
                    _this.trySocialLogin({ fixedSocial: fixedSocial });
                }
            }
            return _this;
        }
        SocialLogin._initState = function (props) {
            var config = props.config, _a = props.tokens, workEmailRoleToken = _a.workEmailRoleToken, userSocialLinkToken = _a.userSocialLinkToken, __initialResponse = props.__initialResponse, startTraditional = props.startTraditional;
            var mergedConfig = mergeConfig(config);
            // controllo se si tratta di un rinnovo o di un login da 0
            var common = {
                workEmailRoleToken: workEmailRoleToken,
                userSocialLinkToken: userSocialLinkToken,
                history: [],
                loading: false,
                socialInput: startTraditional !== undefined
                    ? !startTraditional
                    : !mergedConfig.LOGIN_START_TRADITIONAL,
                // !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                config: mergedConfig,
                forcedChangeWorkEmail: false,
            };
            if (isRenew()) {
                // se sto rinnovando un'autenticazione devo sapere quale forma di login (tradizionale o social) sto rinnovando
                common.socialType = getLoginType();
            }
            if (__initialResponse) {
                // ho una risposta fissata nelle props, sono in un qualche tipo di test, lo inietto nello stato
                common.serverAuth = {
                    success: true,
                    payload: __initialResponse,
                };
            }
            return common;
        };
        SocialLogin.prototype.render = function () {
            var _this = this;
            var _a, _b;
            var _c = this.state, loading = _c.loading, serverAuth = _c.serverAuth, emailDomain = _c.emailDomain, config = _c.config, errors = _c.errors, socialInput = _c.socialInput, forcedChangeWorkEmail = _c.forcedChangeWorkEmail;
            var _d = this.props, authManager = _d.authManager, logo = _d.logo, isModal = _d.isModal, _e = _d.layout, layout = _e === void 0 ? SOCIAL_LOGIN_LAYOUTS.STANDARD : _e, C = _d.customComponent, upgradeRole = _d.upgradeRole, forcedRenewAuthType = _d.forcedRenewAuthType, tokens = _d.tokens;
            // la view del social login viene dedotta a partire dalla risposta del server e alcuni dati aggiuntivi
            var consumerCanRegister = config.AUTH_ROLES.includes(UserRole.Consumer);
            var isUpgradingRole = (typeof upgradeRole === 'boolean' && upgradeRole) ||
                (Array.isArray(upgradeRole) && upgradeRole.length > 0);
            var phase = responseToPhase(serverAuth && serverAuth.payload, forcedRenewAuthType
                ? forcedRenewAuthType !== 'TRADITIONAL'
                : socialInput, loading, isUpgradingRole, getUserData(), consumerCanRegister, forcedChangeWorkEmail, tokens.sfContactId);
            if (phase !== this.initialPhase) {
                var action = { type: 'auth_step_changed', new: phase };
                if (this.initialPhase) {
                    action.old = this.initialPhase;
                }
                track(__assign(__assign({}, authTrackOverride), { action: action }));
            }
            this.initialPhase = phase;
            // TODO ripristinare il sistema di "indietro"
            var socialTypes = config.SOCIAL_TYPES;
            var leftColElem = C ? (React.createElement(C, { layout: layout })) : (React.createElement(Logo, { custom: logo, layout: layout }));
            var user = hasUserAuthData(serverAuth);
            var managed = hasEmailDomainData(serverAuth);
            if (loading) {
                return (React.createElement("div", { className: classNames(style, loadingStep, 'social-login') },
                    React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Sign In / Register"], ["Sign In / Register"])))),
                    React.createElement("div", null, t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["loading"], ["loading"]))),
                        "...")));
            }
            if (serverAuth &&
                phase === AuthSteps.MAIL_CONFIRMED_WAITING_REVIEW) {
                return (React.createElement(StepContainer, null,
                    React.createElement(WaitingReview, { t: t, onClose: function () {
                            return consumerCanRegister
                                ? _this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype)
                                : _this.orLogout();
                        }, isModal: isModal, supportEmail: config.HELP_EMAIL })));
            }
            else if (phase === AuthSteps.CREDENTIAL_INPUT_SOCIAL) {
                return (React.createElement(StepContainer, null,
                    React.createElement(SocialChooseStep, { t: t, socialTypes: socialTypes, logoElem: leftColElem, orLogout: this.orLogout, performLogin: this.trySocialLogin, changePhase: function () {
                            return _this.setState({ socialInput: false });
                        }, layout: layout, authManager: authManager, errors: this.renderError(AuthSteps.CREDENTIAL_INPUT_SOCIAL), isRenew: isRenew() })));
            }
            else if (phase === AuthSteps.CREDENTIAL_INPUT_TRADITIONAL) {
                return (React.createElement(StepContainer, null,
                    React.createElement(TraditionalLogin, { t: t, socialTypes: socialTypes, logoElem: leftColElem, orLogout: this.orLogout, changePhase: function () { return _this.setState({ socialInput: true }); }, onLogin: this.tryTraditionalLogin, layout: layout, isRenew: isRenew(), errors: this.renderError(AuthSteps.CREDENTIAL_INPUT_TRADITIONAL), loading: loading, fixedEmail: getUserData() && getUserData().email })));
            }
            else if (phase === AuthSteps.TERMS_OF_SERVICE) {
                var payload = (_a = this.state.serverAuth) === null || _a === void 0 ? void 0 : _a.payload;
                var tos = payload && isPayloadWithChoices(payload)
                    ? pickToSFromResponse(payload)[0]
                    : null;
                return (React.createElement(StepContainer, null,
                    React.createElement(ToS, { tos: tos, onBack: this.back, onAgree: function (args) { return _this.acceptTos(args); }, t: t, lang: config.LANG })));
            }
            else if (phase === AuthSteps.CHOOSE_ROLE) {
                return (React.createElement(StepContainer, null,
                    React.createElement(ChooseRole, { t: t, back: this.back, roleChooser: this.roleChooser, authManager: authManager, roles: config.AUTH_ROLES })));
            }
            else if (serverAuth && phase === AuthSteps.ASK_WORK_EMAIL) {
                return (React.createElement(StepContainer, null,
                    React.createElement(InsertWorkEmail, { t: t, errors: errors, back: this.back, supportEmail: config.HELP_EMAIL, presetWorkEmail: extractWorkEmail(serverAuth), performRegister: function (email) {
                            _this.performRegister(__assign(__assign({}, _this.state), { email: email.trim().toLowerCase(), forcedChangeWorkEmail: false }));
                        } })));
            }
            else if (serverAuth &&
                phase === AuthSteps.CONFIRMATION_EMAIL_SENT) {
                var workEmail_1 = extractWorkEmail(serverAuth);
                if (!workEmail_1) {
                    Sentry.withScope(function (scope) {
                        scope.setExtra('serverAuth', serverAuth);
                        Sentry.captureException(new Error('AuthSteps.CONFIRMATION_EMAIL_SENT but no workEmail'));
                    });
                }
                return (React.createElement(StepContainer, null,
                    React.createElement(VerificationMessage, { t: t, footer: footer, close: this.close, workEmail: workEmail_1 || t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Unknown email"], ["Unknown email"]))), isModal: isModal, returnToAskEmail: function () {
                            return _this.setState({
                                forcedChangeWorkEmail: true,
                                workEmail: workEmail_1,
                            });
                        }, logout: this.orLogout })));
            }
            else if (serverAuth &&
                phase === AuthSteps.CONFIRMATION_EMAIL_SENT_TEMPORARY_CONSUMER) {
                return (React.createElement(StepContainer, null,
                    React.createElement(TemporaryConsumer, { t: t, proceed: function () {
                            return _this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype);
                        }, isModal: isModal, user: user, workEmail: extractWorkEmail(serverAuth), supportEmail: config.HELP_EMAIL, returnToAskEmail: function () {
                            return _this.historySetState(__assign(__assign({}, _this.state), { forcedChangeWorkEmail: true, workEmail: extractWorkEmail(serverAuth) }));
                        } })));
            }
            else if (phase === AuthSteps.VERIFY_LINK_EXPIRED) {
                return (React.createElement(StepContainer, null,
                    React.createElement(VerifyLinkExpired, { proceed: this.orLogout, t: t, isModal: isModal, supportEmail: config.HELP_EMAIL })));
            }
            else if (serverAuth &&
                phase === AuthSteps.SUCCESSFUL_REGISTRATION) {
                return (React.createElement(StepContainer, null,
                    React.createElement(Success, { t: t, proceed: function () {
                            return _this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype);
                        }, isModal: isModal, user: user, managed: managed, supportEmail: config.HELP_EMAIL })));
            }
            else if (serverAuth &&
                phase === AuthSteps.DOWNGRADED_TO_CONSUMER) {
                return (React.createElement(StepContainer, null,
                    React.createElement(BuyerToConsumer, { t: t, supportEmail: config.HELP_EMAIL, user: user, proceed: function () {
                            return _this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype);
                        }, isModal: isModal })));
            }
            else if (phase === AuthSteps.CHOOSE_EMAIL_DOMAIN) {
                var payload = (_b = this.state.serverAuth) === null || _b === void 0 ? void 0 : _b.payload;
                var domains = payload && isPayloadWithChoices(payload)
                    ? pickEmailDomainsFromResponse(payload)
                    : [];
                // TODO - Assert domains.length >= 1
                return (React.createElement(StepContainer, null,
                    React.createElement(ChooseEmailDomain, { t: t, emailDomain: emailDomain, emailDomains: domains, onChoose: function () { return _this.performRegister(_this.state); }, emailDomainChooser: function (i) {
                            return _this.setState({
                                emailDomain: i.id,
                            });
                        }, supportEmail: config.HELP_EMAIL })));
            }
            else if (phase === AuthSteps.UPGRADE_ROLE) {
                // potrei avere dei ruoli designati per l'upgrade passati direttamente nella chiamata imperativa di
                // `openRenewModal; nel caso non fosse cosi' devo prendere quelli con cui e' stato configurato l'authManager
                var allowedRoles_1 = config.AUTH_ROLES.filter(function (role) {
                    return role !== UserRole.Consumer &&
                        role !== UserRole.Anonymus &&
                        role !== UserRole.Internal;
                });
                var availableRoles = !Array.isArray(upgradeRole)
                    ? allowedRoles_1
                    : upgradeRole.filter(function (role) { return allowedRoles_1.includes(role); });
                if (Array.isArray(upgradeRole) &&
                    upgradeRole.some(function (role) { return allowedRoles_1.indexOf(role) === -1; })) {
                    // check controllo: non dovrebbero esserci ruoli presenti nel richiamo dell'upgrade ma non nella
                    // configurazione generale di auth
                    Sentry.withScope(function (scope) {
                        scope.setExtra('Ruoli impostati da config', allowedRoles_1);
                        scope.setExtra('Ruoli richiesti da chiamata', upgradeRole);
                        Sentry.captureException(new Error('Configurazione errata Auth'));
                    });
                }
                // per l'upgrade adottiamo un approccio generico, non richiedendo all'utente di scegliere il ruolo ma
                // offrendo un generico "professionista". Questo UserRole corrispondera' al primo ruolo a caso fra quelli
                // possibili; stara' poi a noi smistare correttamente l'utente tramite EmailDomain
                var choosenRole_1 = availableRoles[0];
                if (!choosenRole_1) {
                    // sono finito in un caso strano, segnalo il problema ma provo ad offrire una soluzione
                    Sentry.captureException(new Error("Nessun ruolo richiesto per l'upgrade risulta permesso"));
                    choosenRole_1 = allowedRoles_1[0];
                    if (!choosenRole_1) {
                        // caso ancora piu' strano: non ho proprio ruoli accessibili. Segnalo l'errore e restituisco
                        // una schermata di errore tecnico
                        Sentry.captureException(new Error('Chiamato upgrade, ma nessun ruolo permesso'));
                        return (React.createElement(StepContainer, null,
                            React.createElement(ErrorStep, { error: t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["cannot upgrade error"], ["cannot upgrade error"]))), t: t, isModal: isModal, supportEmail: config.HELP_EMAIL, close: this.close })));
                    }
                }
                return (React.createElement(StepContainer, null,
                    React.createElement(ChooseUpgradeRole, { t: t, upgrade: function () { return _this.upgradeRole(choosenRole_1); }, close: this.close })));
            }
            else if (serverAuth && phase === AuthSteps.SWITCH_TO_SOCIAL) {
                return (React.createElement(StepContainer, null,
                    React.createElement(SwitchToSocialStep, { t: t, authManager: authManager, socialTypes: socialTypes, performLogin: this.trySocialUpgrade, maybeLaterHandler: function () {
                            return _this.successfulLoginHandler(serverAuth, 'TRADITIONAL');
                        }, layout: layout })));
            }
            else if (serverAuth &&
                phase === AuthSteps.REMIND_SOCIAL_ACCOUNT) {
                var socialType = pickSocialTypeFromResponse(serverAuth.payload);
                if (!socialType) {
                    // check controllo: non dovrebbero esserci ruoli presenti nel richiamo dell'upgrade ma non nella
                    // configurazione generale di auth
                    Sentry.withScope(function (scope) {
                        scope.setExtra('serverAuth.payload', serverAuth.payload);
                        Sentry.captureException(new Error('AuthSteps.REMIND_SOCIAL_ACCOUNT without socialtype'));
                    });
                    this.successfulLoginHandler(serverAuth, 'TRADITIONAL');
                    return (React.createElement(StepContainer, null,
                        React.createElement(ErrorStep, { error: t(templateObject_5 || (templateObject_5 = __makeTemplateObject(["AuthSteps.REMIND_SOCIAL_ACCOUNT without socialtype"], ["AuthSteps.REMIND_SOCIAL_ACCOUNT without socialtype"]))), t: t, isModal: isModal, supportEmail: config.HELP_EMAIL, close: this.close })));
                }
                return (React.createElement(StepContainer, null,
                    React.createElement(RememberSocialStep, { t: t, proceed: function () {
                            return _this.successfulLoginHandler(serverAuth, 'TRADITIONAL');
                        }, socialType: socialType })));
            }
            else {
                // viste le condizioni precedenti, questo implica `phase instanceOf Error === true`
                return (React.createElement(StepContainer, null,
                    React.createElement(ErrorStep, { error: this.renderError(), t: t, isModal: isModal, supportEmail: config.HELP_EMAIL, close: function () { return (isModal ? _this.close() : _this.orLogout()); } })));
            }
        };
        return SocialLogin;
    }(React.Component)));
}
export { socialLoginFactory };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=SocialLogin.js.map